<template>
  <div class="container commentlist">
    <div class="h" v-if="$route.query.pt == 'app' || $route.query.pt == 'ckapp'"></div>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
    >
      <div class="choose_list" v-if="$route.path == '/commentList'">
        <div class="tags" v-if="tagslist && tagslist.length">
          <ul>
            <li v-if="item" v-for="(item, index) of tagslist">{{ item }}</li>
          </ul>
        </div>
        <ul>
          <li :class="{ ative: typeIndex === 1 }" @click="chooseType(1)">全部</li>
          <li :class="{ ative: typeIndex === 2 }" @click="chooseType(2)">有图</li>
          <li :class="{ ative: typeIndex === 0 }" @click="chooseType(0)">按评价</li>
        </ul>
      </div>
      <div class="pro_comment">
        <div class="pro_comment_list">
          <div class="pro_comment_item" v-for="(item, index) of list" :key="index">
            <div class="comment_head_info" @click="commentDetail(item)">
              <div class="sj">
                <van-rate
                  v-model="item.itemscore"
                  :size="15"
                  void-color="#eeeeee"
                  void-icon="star"
                  color="#FFCD07"
                  readonly
                />
              </div>
              <div class="img">
                <img
                  v-if="item.head"
                  :src="item.head"
                  @error="
                    function (event) {
                      let img = event.srcElement
                      img.src = errorHeadImg
                      img.onerror = null
                    }
                  "
                />
                <img v-if="!item.head" :src="errorHeadImg" />
              </div>
              <div class="info">
                <div class="name">
                  {{ item.smallname }}
                  <img
                    v-if="item.vip_level"
                    :src="`/static/images/vipIcon/l${item.vip_level}.png`"
                  />
                </div>
                <div class="time">
                  {{ item.time }}
                  <span class="spec">规格：{{ item.spec }}</span>
                </div>
              </div>
            </div>
            <div class="comment_content_info">
              <div class="comment_txt" @click="commentDetail(item)">
                <span class="color-FC0324 f10 isfeedback" v-if="item.isfeedback">
                  &nbsp;试用反馈&nbsp;
                </span>
                {{ item.content }}
              </div>
              <div class="comment_pic">
                <!-- Swiper -->
                <div class="swiper-container">
                  <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide style="position: relative" v-if="item.isvideo == 1">
                      <div style="width: 100%; height: 100%">
                        <video
                          style="width: 100%; height: 100%; object-fit: cover"
                          class="videofile"
                          id="videofile"
                          :poster="item.coverimg"
                          :src="item.videourl"
                          webkit-playsinline="true"
                          playsinline="true"
                          x5-playsinline="true"
                          x-webkit-airplay="allow"
                          preload="true"
                        >
                          <source :src="item.videourl" type="video/mp4" />
                          您的浏览器不支持 video 标签。
                        </video>
                        <img
                          style="
                            position: absolute;
                            left: 34%;
                            top: 30%;
                            width: 0.28rem;
                            height: 0.28rem;
                          "
                          @click="playFn(item.videourl)"
                          v-if="!isfullscreen"
                          src="/static/images/community/video.png"
                        />
                      </div>
                    </swiper-slide>
                    <swiper-slide v-if="item.path1">
                      <img v-lazy="item.path1" @click="preview(item, 0)" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path2">
                      <img v-lazy="item.path2" @click="preview(item, 1)" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path3">
                      <img v-lazy="item.path3" @click="preview(item, 2)" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path4">
                      <img v-lazy="item.path4" @click="preview(item, 3)" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path5">
                      <img v-lazy="item.path5" @click="preview(item, 4)" />
                    </swiper-slide>
                    <swiper-slide v-if="item.path6">
                      <img v-lazy="item.path6" @click="preview(item, 5)" />
                    </swiper-slide>
                  </swiper>
                  <!-- Add Pagination -->
                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>
            <div class="comment_oper" v-if="$route.query.onlyshow != 1">
              <div class="button" @click="commentLike(item)">
                <img
                  :src="
                    item.islike == 0
                      ? require('../../assets/images/zan.png')
                      : require('../../assets/images/zan1.png')
                  "
                />
                {{ parseInt(item.like_nums) > 0 ? item.like_nums : '点赞' }}
              </div>
              <div class="button" @click="commentDetail(item)">
                <img src="../../assets/images/ly.png" />
                {{ parseInt(item.leave_nums) > 0 ? item.leave_nums : '留言' }}
              </div>
            </div>
          </div>
          <p
            v-if="$route.path == '/commentList' && foldcommentnum"
            class="footer"
            @click="commentList_1"
          >
            已折叠{{ foldcommentnum }}条对您帮助不大的评价
            <img src="../../../static/images/jt.png" />
          </p>
          <p v-else="finished" class="footer">{{ noDataText }}</p>
        </div>
      </div>
    </Scroller>
    <div v-if="showsVideo" class="van-uploader__wrapper">
      <div
        class="van-uploader__upload"
        :class="{ fullscreen: isfullscreen }"
        style="position: relative; width: 1.05rem; height: 1.05rem; background: #333333"
      >
        <video
          @click="playFn2"
          class="videofile"
          id="videofile2"
          :src="fullVideoUrl"
          webkit-playsinline="true"
          playsinline="true"
          x5-playsinline="true"
          x-webkit-airplay="allow"
          preload="true"
        >
          <source :src="fullVideoUrl" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import Scroller from '../common/Scroller'
import { Rate, ImagePreview } from 'vant'
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)
export default {
  name: 'commentList',
  components: {
    [Rate.name]: Rate,
    Scroller
  },
  data() {
    return {
      value: 5,
      typeIndex: 1,
      list: [],
      tagslist: [],
      swiperOption: {
        slidesPerView: 3.6,
        spaceBetween: 7,
        observer: true,
        observeParents: true
      },
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '',
      isfullscreen: false,
      showsVideo: false,
      fullVideoUrl: '',
      foldcommentnum: 0,
      itemid: ''
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'commentlist' })
    }
    this.itemid = this.$route.query.itemid
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        if (vm.itemid != vm.$route.query.itemid) {
          vm.$store.commit('COMMENT_INIT_DATA', 1)
        }
        if (vm.$store.state.commentInitData == 1) {
          Object.assign(vm.$data, vm.$options.data())
          if (vm.$store.state.commentInitData == 1 && vm && vm.$refs.my_scroller) {
            // 通过vm实例访问this
            vm.$store.commit('COMMENT_INIT_DATA', 0)
            setTimeout(function () {
              window.scrollTo(0, sessionStorage.askPositon, false)
            }, 100) // 同步转异步操作
          }
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (to.path == '/productdetail') this.loading = true
    next()
  },
  methods: {
    playFn(url) {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      this.fullVideoUrl = url
      this.$nextTick(() => {
        if (this.isfullscreen) {
          document.getElementById('videofile2').play()
        } else {
          document.getElementById('videofile2').pause()
        }
      })
    },
    playFn2() {
      this.showsVideo = !this.showsVideo
      this.isfullscreen = !this.isfullscreen
      if (this.isfullscreen) {
        document.getElementById('videofile2').play()
      } else {
        document.getElementById('videofile2').pause()
      }
    },
    getData: function () {
      var url = ''
      if (this.$route.path == '/commentList_1') {
        this.typeIndex = 3
      }
      if (this.typeIndex != 0 && this.$route.query.itemid) {
        url =
          this.$ajax.getCommentList_URL +
          '?item_base_id=' +
          this.$route.query.itemid +
          '&pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&type=' +
          this.typeIndex +
          '&sort=0'
      } else if (this.typeIndex == 0 && this.$route.query.itemid) {
        url =
          this.$ajax.getCommentList_URL +
          '?item_base_id=' +
          this.$route.query.itemid +
          '&pageno=' +
          this.nowPage +
          '&type=1&pagesize=' +
          this.pagesize +
          '&sort=' +
          1
      }
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.tagslist = res.data.taglist
          that.foldcommentnum = res.data.foldcommentnum ? parseInt(res.data.foldcommentnum) : 0
          if (that.foldcommentnum && that.typeIndex != 3) {
            that.noDataText = ''
          } else {
            that.noDataText = '—— 客官，木有啦~ ——'
          }
          // that.tagslist = ['会回购', '很划算', '包装很好', '性价比超高', '敏感肌专属', '正品']
          if (that.nowPage === 1) {
            that.list = res.data.list
            that.list.map((item) => {
              item.itemscore = parseInt(item.itemscore)
            })
            that.refresh = false
          } else {
            that.list = that.list.concat(res.data.list)
          }
          that.loading = false
          if (res.data.list.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.list = []
      var that = this
      that.getData()
      // this.editorClick()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    preview(items, index) {
      var imgArr, newImgArr
      imgArr = [items.path1, items.path2, items.path3, items.path4, items.path5, items.path6]
      newImgArr = []
      imgArr.map((item) => {
        if (item && item != undefined) {
          newImgArr.push(item)
        }
      })
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    chooseType(type) {
      this.typeIndex = type
      this.nowPage = 1
      this.getData()
    },
    commentDetail(items) {
      if (this.$route.query.onlyshow == 1) return
      var query = this.$route.query
      query.commentid = items.id
      this.$router.push({ path: '/commentDetail', query: query })
    },
    commentList_1() {
      this.$store.commit('COMMENT_INIT_DATA', 1)
      var query = this.$route.query
      this.$router.push({ path: '/commentList_1', query: query })
    },
    commentLike(items) {
      var url = this.$ajax.addCommentLike_URL
      var data = {}
      if (items.islike == 0) {
        data = {
          id: items.id,
          type: 1
        }
      } else if (items.islike == 1) {
        data = {
          id: items.id,
          type: 2
        }
      }
      var that = this
      that.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          if (items.islike == 0) {
            items.islike = 1
            items.like_nums = parseInt(items.like_nums) + 1
          } else if (items.islike == 1) {
            items.islike = 0
            items.like_nums = parseInt(items.like_nums) - 1
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background-color: #fff;
  &.commentlist {
    .h {
      height: 0.5rem;
    }
  }
  &.commentlist .tags {
    ul {
      margin-top: -0.05rem;
      margin-bottom: -0.05rem;
      li {
        width: 30%;
        height: 0.28rem;
        text-align: center;
        color: #fc0324;
        font-size: 0.12rem;
        border: 0.01rem solid #f4f4f4;
        border-radius: 0.06rem;
        background: #ffffff;
        margin-top: 0.1rem;
        white-space: nowrap;
      }
    }
  }
  .choose_list {
    overflow: hidden;
    background-color: #fff;
    ul {
      padding: 0.1rem 0.15rem;
      overflow: hidden;
      li {
        list-style: none;
        float: left;
        font-size: 0.12rem;
        color: #5e5e5e;
        padding: 0.06rem 0.15rem;
        border-radius: 0.15rem;
        background-color: #eeeff4;
        margin-right: 0.1rem;
        border: solid 1px #eeeff4;
        font-weight: 400;
      }
      li.ative {
        color: #fc0324;
        background-color: #fcedeb;
        border: solid 1px #fc0324;
        font-weight: 700;
      }
    }
  }
  .pro_comment {
    padding: 0 0.11rem;
    .pro_comment_item {
      margin-top: 0.2rem;
      .comment_head_info {
        position: relative;
        overflow: hidden;
        .sj {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 9;
          font-size: 0.12rem;
          .van-icon-star {
            font-size: 0.13rem;
          }
        }
        .img {
          width: 0.37rem;
          float: left;
          img {
            width: 0.37rem;
            height: 0.37rem;
            border-radius: 0.37rem;
          }
        }
        .info {
          float: left;
          position: relative;
          left: 0.1rem;
          .name {
            font-size: 0.14rem;
            line-height: 0.2rem;
            width: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            img {
              width: 0.32rem;
              height: 0.15rem;
              display: inline-block;
              vertical-align: middle;
            }
          }

          .time {
            font-size: 0.1rem;
            /*transform: scale(0.85);*/
            color: #afb0af;
            margin-bottom: 0.1rem;
            .spec {
              margin-left: 0.16rem;
            }
          }
        }
      }
      .comment_content_info {
        padding-left: 0.47rem;
        .comment_txt {
          font-size: 0.14rem;
          line-height: 0.2rem;
          color: #6d6d6d;
          width: 100%;
          word-break: break-word;
          .isfeedback {
            border-radius: 0.02rem;
            border: 0.01rem solid #fc0324;
            margin-right: 0.02rem;
          }
        }
        .comment_pic {
          margin-top: 0.05rem;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide {
              text-align: center;
              height: 0.79rem;
              font-size: 18px;
              background: #fff;
              display: -webkit-box;
              display: -ms-flexbox;
              display: -webkit-flex;
              display: flex;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              -webkit-justify-content: center;
              justify-content: center;
              -webkit-box-align: center;
              -ms-flex-align: center;
              -webkit-align-items: center;
              align-items: center;
              border-radius: 0.04rem;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                /*height: .85rem;*/
                border-radius: 0.04rem;
                object-fit: cover;
                overflow: hidden;
              }
            }
          }
        }
      }
      .comment_oper {
        overflow: hidden;
        .button {
          /*border: solid 1px #606060;*/
          padding: 0.04rem 0.08rem;
          display: inline-block;
          border-radius: 0.15rem;
          font-size: 0.11rem;
          color: #6d6d6d;
          float: right;
          margin-left: 0.15rem;
          margin-top: 0.1rem;
          img {
            width: 0.16rem;
            height: 0.16rem;
            display: block;
            float: left;
            margin-right: 0.05rem;
          }
        }
      }
    }
    .footer {
      color: #888888;
      font-size: 0.13rem;
      background: #fff;
      text-align: center;
      padding: 0.08rem 0 0.14rem;
      line-height: 0.16rem;
      img {
        width: 0.065rem;
        height: 0.11rem;
        display: inline-block;
        margin-left: 0.04rem;
      }
    }
  }
}
.van-uploader__wrapper,
.poster-upload .van-uploader__input-wrapper {
  width: 100%;
  height: 0.22rem;
  position: relative;
}
.van-uploader__preview {
  display: none !important;
}
.van-uploader__upload,
.van-uploader__preview {
  overflow: hidden !important;
  border-radius: 0.03rem !important;
  border-color: #979797;
  &.fullscreen video {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    border-width: 0 !important;
    z-index: 10000;
    background: #222222;
    .van-uploader__preview-delete:before {
      display: none !important;
    }
  }
  .videofile {
    height: 100%;
    width: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
</style>
<style lang="scss">
.commentlist {
  .scroller {
    /*padding-top: 0.4rem;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productdetail/commentList.vue